import safeCreateAction from "../../../actions/safeCreateAction";
export const setPhaseCount = safeCreateAction("SET_DISCOVERY_PHASE_COUNT", (count) => count);
export const discoveryProgress = safeCreateAction("DISCOVERY_PROGRESS", (idx, percent, directory) => ({
    idx,
    percent,
    directory,
}));
export const discoveryFinished = safeCreateAction("DISCOVERY_FINISHED");
